import React from 'react';
import styles from './ExpiryDateReport.module.scss';
import DataTable from 'react-data-table-component';
import FilterInTable from '../../../../Manage/FilterInTable';

const data = [
    {
        id: 1,
        productId: '001',
        productName: 'Milk Chocolate',
        expiryDate: '12/07/2024',
        stockLevel: 300,
        sellToDate: '07/07/2024',
        batchNumber: 'B1234',
        location: 'Warehouse 1',
        action: 'Promotion',
    },
    {
        id: 2,
        productId: '001',
        productName: 'Milk Chocolate',
        expiryDate: '12/07/2024',
        stockLevel: 300,
        sellToDate: '07/07/2024',
        batchNumber: 'B1234',
        location: 'Warehouse 1',
        action: 'Promotion',
    },
    {
        id: 3,
        productId: '001',
        productName: 'Milk Chocolate',
        expiryDate: '12/07/2024',
        stockLevel: 300,
        sellToDate: '07/07/2024',
        batchNumber: 'B1234',
        location: 'Warehouse 1',
        action: 'Promotion',
    },
    {
        id: 4,
        productId: '001',
        productName: 'Milk Chocolate',
        expiryDate: '12/07/2024',
        stockLevel: 300,
        sellToDate: '07/07/2024',
        batchNumber: 'B1234',
        location: 'Warehouse 1',
        action: 'Promotion',
    },
    {
        id: 5,
        productId: '001',
        productName: 'Milk Chocolate',
        expiryDate: '12/07/2024',
        stockLevel: 300,
        sellToDate: '07/07/2024',
        batchNumber: 'B1234',
        location: 'Warehouse 1',
        action: 'Promotion',
    },
];

const columns = [
    {
        name: 'Product ID',
        selector: (row) => row.productId,
        sortable: true,
        width: '160px',
    },
    {
        name: 'Product Name',
        selector: (row) => row.productName,
        sortable: true,
        width: '250px',
    },
    {
        name: 'Expiry Date',
        selector: (row) => row.expiryDate,
        sortable: true,
        width: '180px',
    },
    {
        name: 'Current Stock Level',
        selector: (row) => row.stockLevel,
        sortable: true,
        width: '240px',
    },
    {
        name: 'Sell-to-date',
        selector: (row) => row.sellToDate,
        sortable: true,
        width: '180px',
    },
    {
        name: 'Batch/Lot Number',
        selector: (row) => row.batchNumber,
        sortable: true,
        width: '220px',
    },
    {
        name: 'Location',
        selector: (row) => row.location,
        sortable: true,
        width: '180px',
    },
    {
        name: 'Action',
        selector: (row) => row.action,
        sortable: true,
        width: '180px',
    },
];

const customStyles = {
    table: {
        style: {
            borderLeft: '1px solid #D9D9D9',
            borderTop: '1px solid #D9D9D9',
        },
    },
    headRow: {
        style: {
            backgroundColor: '#FBBD34',
            color: '#FFFFFF',
            fontSize: '16px',
            fontWeight: '600',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            paddingLeft: "20px",
            paddingRight: "20px",
            borderRight: '1px solid #D9D9D9',
            div: {
                whiteSpace: "normal",
                overflow: "visible",
            },
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '15px 20px',
            borderRight: '1px solid #D9D9D9',
            div: {
                whiteSpace: "normal !important",
                overflow: "visible !important",
            },
        },
    },
};

const ExpiryDateReport = () => {

    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.sectionHeading}>Expiry Date Report</h4>

            <div className={styles.filterTableContainer}>

                <FilterInTable componentName={"Expiry Date Report"} />

                <div className={styles.table}>
                    <DataTable
                        columns={columns}
                        data={data}
                        pagination
                        highlightOnHover
                        customStyles={customStyles}
                    />
                </div>
            </div>
        </div>
    )
}

export default ExpiryDateReport;